import {
  Order,
  OrderDaasInfoStatus,
  Coordinates,
  Address,
  OrderTrackingStatusTextsView,
  OrderTrackingStatusTextType,
  ProgressBarFragment,
  BoxTheme,
  GetTextByKeyType
} from '@box-types';
import { diffDays } from '../core';
import dayjs from 'dayjs';
import { GoogleMap } from '@angular/google-maps';
import { getOrderDaasStatus, isOrderDaas, isOrderDaasBeforeShipping } from './order-daas.utils';
import {
  isOrderAccepted,
  isOrderPending,
  isOrderRejected,
  isOrderScheduled,
  getOrderDeliveryStatus,
  isOrderCompleted,
  isNotOrderCompleted
} from './order-status.utils';
import { getOrderShopStatus } from './order.utils';
import { getDaasMapStyles } from '../maps';
import { getAddressType } from '../address';

export {
  orderTrackingStatusTexts,
  getOrderAcceptedStatusText,
  getOrderTrackingStatusEstimationText,
  getScheduledOrderDeliveryEstimationTimeText,
  getCeiledDeliveryTime,
  getNormalOrderDeliveryEstimationTime,
  getDAASUnassignedDeliveryEstimationTime,
  getOrderStatusTimeText,
  canShowDeliveryMarker,
  coordinatesToLatLng,
  getDaasMapOptions,
  getShopMarkerOptions,
  getDeliveryMarkerOptions,
  getAddressMarkerOptions,
  orderRequiresPolling,
  shouldShowLiveTrackingMap,
  getDaasEstimatedArrivalDateString,
  getDaasShippedOrderTimeOfArrival,
  shouldShowDaasTimingsBeforeProgress,
  generateDaasOrderProgressBarFragments,
  generateOrderProgressBarFragments,
  getCoordinatesFromMarkerOptions,
  isMarkerInsideMapBounds,
  canFocusOnUserAndDelivery,
  getTakeAwayTrackingStatusEstimationText,
  getNonDaasTrackingStatusEstimationText,
  getDaasTrackingStatusEstimationText,
  isNormalOrderDeliveryCompletedToday,
  getNormalOrderDeliveryCompletionTimeText,
  getNormalOrderDeliveryEstimationTimeText,
  getOrderTileStatusEstimationText,
  getNonDaasOrderTileStatusEstimationText,
  getOrderTileStatusTimeText,
  getNormalOrderTileStatusEstimationTimeText,
  getDaasOrderStatusTimeText
};

const DeliveryPinSVG = `<svg width="46" height="54" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse opacity=".5" cx="23" cy="49" rx="19" ry="4" fill="url(#a)"/><g filter="url(#b)"><path fill-rule="evenodd" clip-rule="evenodd" d="M23 5C12.507 5 4 13.507 4 24c0 8.703 5.851 16.039 13.834 18.29L23 49l5.166-6.71C36.149 40.038 42 32.702 42 24c0-10.493-8.507-19-19-19Z" fill="#fff"/></g><rect x="8" y="9" width="30" height="30" rx="15" fill="#F87A1D"/><path d="M23.979 24.784v2.318a.582.582 0 0 1-.177.417.61.61 0 0 1-.854 0 .582.582 0 0 1-.177-.417v-2.047l-1.147-.964 2.355.693Zm0 0a.578.578 0 0 0-.056-.246m.056.246-.056-.246m-1.512-1.34 1.357 1.14-1.357-1.14Zm0 0a.563.563 0 0 1-.203-.423m.203.423-.203-.423m0 0a.538.538 0 0 1 .159-.404l1.165-.904m-1.324 1.308 1.324-1.308m0 0a.597.597 0 0 1 .828.037m-.828-.038.828.038m0 0h.001m0 0 1.544 1.392m-1.544-1.391-2.777-.032m0 0 1.166-.904a1.801 1.801 0 0 1 1.243-.435 1.795 1.795 0 0 1 1.208.524l1.348 1.215h1.576a.61.61 0 0 1 .427.173.582.582 0 0 1 0 .834.611.611 0 0 1-.427.173h-1.81a.612.612 0 0 1-.41-.157M25.904 22.896l.008-.008m-.007.008.006-.008m0 0-1.543-1.39 2.178.386h1.579a.6.6 0 0 1 .42.17.573.573 0 0 1 0 .819.601.601 0 0 1-.42.17h-1.81a.602.602 0 0 1-.404-.155Zm-4.328-1.415a1.75 1.75 0 0 0-.436.598m.437-.598-.437.598m2.776 2.467a.591.591 0 0 0-.155-.2l.155.2Zm-2.776-2.467c-.1.227-.15.473-.147.72m.147-.72-.147.72m0 0c.004.247.062.491.17.715m-.17-.715.17.715m0 0c.107.225.262.424.454.585l-.455-.585Zm-3.606 6.014a3.031 3.031 0 0 0 3.76-.363 2.876 2.876 0 0 0 .873-2.055c0-.575-.174-1.137-.502-1.615a2.964 2.964 0 0 0-1.336-1.071 3.046 3.046 0 0 0-1.721-.166 3.002 3.002 0 0 0-1.526.796c-.416.407-.7.925-.815 1.489a2.844 2.844 0 0 0 .17 1.68c.225.531.607.986 1.097 1.305Zm.67-3.855a1.802 1.802 0 0 1 2.237.215 1.7 1.7 0 0 1 .22 2.183 1.764 1.764 0 0 1-.794.636c-.324.131-.68.165-1.024.099a1.785 1.785 0 0 1-.907-.473 1.717 1.717 0 0 1-.485-.886 1.69 1.69 0 0 1 .101-.998c.134-.316.361-.586.653-.776Zm7.642 3.855a3.03 3.03 0 0 0 3.76-.363 2.876 2.876 0 0 0 .874-2.055c0-.575-.175-1.137-.502-1.615a2.964 2.964 0 0 0-1.337-1.071 3.046 3.046 0 0 0-1.72-.166 3.002 3.002 0 0 0-1.526.796c-.417.407-.7.925-.815 1.489a2.844 2.844 0 0 0 .17 1.68c.225.531.607.986 1.096 1.305Zm.671-3.855a1.802 1.802 0 0 1 2.237.215 1.7 1.7 0 0 1 .22 2.183 1.764 1.764 0 0 1-.795.636c-.323.131-.68.165-1.023.099a1.785 1.785 0 0 1-.907-.473 1.716 1.716 0 0 1-.485-.886 1.69 1.69 0 0 1 .1-.998c.135-.316.362-.586.653-.776Zm-.5-8.425a1.52 1.52 0 0 0-.83.246c-.246.16-.438.388-.55.654-.114.267-.144.56-.086.843.058.284.2.543.41.747.208.204.474.343.764.4.29.056.59.027.864-.083.273-.11.506-.298.67-.538a1.434 1.434 0 0 0-.186-1.842 1.513 1.513 0 0 0-1.056-.427Z" fill="#fff" stroke="#fff" stroke-width=".02"/><path d="M21.95 19.336c0 .291-1.426 1.81-1.78 1.81-.356 0-1.773-1.228-.351-2.101 1.42-.873 2.131 0 2.131.291Z" fill="#fff" stroke="#fff"/><defs><radialGradient id="a" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 4 -19 0 23 49)"><stop stop-opacity=".49"/><stop offset=".906" stop-opacity="0"/></radialGradient><filter id="b" x="0" y="0" width="46" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="1"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.160784 0 0 0 0 0.180392 0 0 0 0.1 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_4767_44766"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="-1"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.160784 0 0 0 0 0.180392 0 0 0 0.1 0"/><feBlend in2="effect1_dropShadow_4767_44766" result="effect2_dropShadow_4767_44766"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_4767_44766" result="shape"/></filter></defs></svg>`;
const HomeAddressPinSVG = `<svg width="46" height="54" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse opacity=".5" cx="23" cy="49" rx="19" ry="4" fill="url(#a)"/><g filter="url(#b)"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 5a4 4 0 0 0-4 4v30a4 4 0 0 0 4 4h9.804L23 49l5.196-6H38a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4H8Z" fill="#fff"/></g><rect x="8" y="9" width="30" height="30" rx="4" fill="#2A292E"/><path d="M21.5 30v-4.5h3V30h3.75v-6h2.25L23 17.25 15.5 24h2.25v6h3.75Z" fill="#fff"/><defs><radialGradient id="a" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 4 -19 0 23 49)"><stop stop-opacity=".49"/><stop offset=".906" stop-opacity="0"/></radialGradient><filter id="b" x="0" y="0" width="46" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="1"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.160784 0 0 0 0 0.180392 0 0 0 0.1 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_4767_44763"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="-1"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.160784 0 0 0 0 0.180392 0 0 0 0.1 0"/><feBlend in2="effect1_dropShadow_4767_44763" result="effect2_dropShadow_4767_44763"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_4767_44763" result="shape"/></filter></defs></svg>`;
const WorkAddressPinSVG = `<svg width="46" height="54" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse opacity=".5" cx="23" cy="49" rx="19" ry="4" fill="url(#a)"/><g filter="url(#b)"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 5a4 4 0 0 0-4 4v30a4 4 0 0 0 4 4h9.804L23 49l5.196-6H38a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4H8Z" fill="#fff"/></g><rect x="8" y="9" width="30" height="30" rx="4" fill="#2A292E"/><path d="M28.625 20.063h-2.813V19.5c0-.62-.504-1.125-1.125-1.125h-3.375c-.62 0-1.125.505-1.125 1.125v.563h-2.812c-.62 0-1.125.504-1.125 1.125v1.687c0 .62.505 1.125 1.125 1.125h4.5v-.281c0-.156.126-.282.281-.282h1.688c.155 0 .281.126.281.282V24h4.5c.62 0 1.125-.505 1.125-1.125v-1.688c0-.62-.505-1.125-1.125-1.125Zm-3.938 0h-3.375V19.5h3.375v.563ZM29.594 24.303a.282.282 0 0 0-.295.028 1.11 1.11 0 0 1-.674.232h-4.5v.843a.281.281 0 0 1-.281.282h-1.688a.281.281 0 0 1-.281-.282v-.843h-4.5a1.11 1.11 0 0 1-.674-.232.281.281 0 0 0-.451.224V28.5c0 .62.505 1.125 1.125 1.125h11.25c.62 0 1.125-.505 1.125-1.125v-3.945a.281.281 0 0 0-.156-.252Z" fill="#fff"/><defs><radialGradient id="a" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 4 -19 0 23 49)"><stop stop-opacity=".49"/><stop offset=".906" stop-opacity="0"/></radialGradient><filter id="b" x="0" y="0" width="46" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="1"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.160784 0 0 0 0 0.180392 0 0 0 0.1 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_4767_44764"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="-1"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.160784 0 0 0 0 0.180392 0 0 0 0.1 0"/><feBlend in2="effect1_dropShadow_4767_44764" result="effect2_dropShadow_4767_44764"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_4767_44764" result="shape"/></filter></defs></svg>`;
const GeneralAddressPinSVG = `<svg fill="none" height="54" width="46" xmlns="http://www.w3.org/2000/svg"><filter id="b" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse" height="54" width="46" x="0" y="0"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.160784 0 0 0 0 0.180392 0 0 0 0.1 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_4767_44765"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="-1"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.160784 0 0 0 0 0.180392 0 0 0 0.1 0"/><feBlend in2="effect1_dropShadow_4767_44765" result="effect2_dropShadow_4767_44765"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_4767_44765" result="shape"/></filter><radialGradient id="a" cx="0" cy="0" gradientTransform="matrix(0 4 -19 0 23 49)" gradientUnits="userSpaceOnUse" r="1"><stop offset="0" stop-opacity=".49"/><stop offset=".906" stop-opacity="0"/></radialGradient><ellipse cx="23" cy="49" fill="url(#a)" opacity=".5" rx="19" ry="4"/><g filter="url(#b)"><path clip-rule="evenodd" d="M8 5a4 4 0 0 0-4 4v30a4 4 0 0 0 4 4h9.804L23 49l5.196-6H38a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4z" fill="#fff" fill-rule="evenodd"/></g><rect fill="#2a292e" height="30" rx="4" width="30" x="8" y="9"/><path d="M23 16.5a3.75 3.75 0 1 1 0 7.5 3.75 3.75 0 0 1 0-7.5zm0 9.375c4.144 0 7.5 1.678 7.5 3.75V31.5h-15v-1.875c0-2.072 3.356-3.75 7.5-3.75z" fill="#fff"/></svg>`;
const ShopAddressPinSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="46" height="54" fill="none"><ellipse cx="23" cy="49" fill="url(#a)" opacity=".5" rx="19" ry="4"/><g filter="url(#b)"><path fill="#fff" fill-rule="evenodd" d="M8 5a4 4 0 0 0-4 4v30a4 4 0 0 0 4 4h9.804L23 49l5.196-6H38a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4H8Z" clip-rule="evenodd"/></g><rect width="30" height="30" x="8" y="9" fill="#F87A1D" rx="4"/><path fill="#fff" d="m27.863 30.74-.712-5.223h.02c.209 0 .378-.165.378-.37V17.62c0-.13-.069-.25-.183-.317a.386.386 0 0 0-.372-.01c-1.476.761-2.4 2.259-2.4 3.892v3.173c0 .64.53 1.16 1.185 1.16h.09l-.712 5.221c-.052.381.067.766.326 1.055.26.29.634.456 1.027.456a1.38 1.38 0 0 0 1.027-.456c.26-.289.378-.674.326-1.055Zm-5.672-13.49a.515.515 0 0 0-.527.502v2.805h-.527v-2.805a.515.515 0 0 0-.528-.502.515.515 0 0 0-.527.502v2.805h-.527v-2.805a.515.515 0 0 0-.528-.502.515.515 0 0 0-.527.502v4.532c0 .744.634 1.348 1.416 1.348h.117l-.831 7.121c-.044.381.084.762.352 1.048.269.286.653.449 1.055.449a1.45 1.45 0 0 0 1.056-.45c.268-.285.396-.666.352-1.047l-.831-7.121h.117c.782 0 1.416-.604 1.416-1.348v-4.532a.515.515 0 0 0-.528-.502Z"/><defs><radialGradient id="a" cx="0" cy="0" r="1" gradientTransform="matrix(0 4 -19 0 23 49)" gradientUnits="userSpaceOnUse"><stop stop-opacity=".49"/><stop offset=".906" stop-opacity="0"/></radialGradient><filter id="b" width="46" height="54" x="0" y="0" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.160784 0 0 0 0 0.180392 0 0 0 0.1 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_209_39308"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="-1"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.164706 0 0 0 0 0.160784 0 0 0 0 0.180392 0 0 0 0.1 0"/><feBlend in2="effect1_dropShadow_209_39308" result="effect2_dropShadow_209_39308"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_209_39308" result="shape"/></filter></defs></svg>`;

const DEFAULT_MAP_OPTIONS: google.maps.MapOptions = {
  maxZoom: 18,
  mapTypeControl: false,
  fullscreenControl: false,
  scaleControl: true,
  streetViewControl: false
};

const DEFAULT_MARKER_OPTIONS: google.maps.MarkerOptions = {
  animation: typeof google !== 'undefined' ? google.maps.Animation.DROP : undefined
};

/* Order Tracking Status Text */
const orderTrackingStatusTexts: Record<OrderTrackingStatusTextsView, Record<OrderTrackingStatusTextType, string>> = {
  main: {
    ACCEPTED_STATUS_TEXT: 'your_order_has_been_accepted',
    DAAS_NEARBY_STATUS_TEXT: 'your_order_is_very_closed',
    DAAS_UNASSIGNED_STATUS_TEXT: 'your_order_is_being_prepared',
    DAAS_ASSIGNED_STATUS_TEXT: 'your_order_is_being_prepared',
    DAAS_STARTED_STATUS_TEXT: 'navigating_to_restaurant',
    DAAS_ARRIVING_AT_SHOP_STATUS_TEXT: 'receiving_your_order',
    DAAS_SHIPPING_STATUS_TEXT: 'your_order_is_on_its_way',
    DAAS_SHIPPED_STATUS_TEXT: 'thank_you_for_choosing_us',
    NON_DAAS_THANKYOU_TEXT: 'thank_you_for_choosing_us'
  },
  orderStatus: {
    ACCEPTED_STATUS_TEXT: 'your_order_has_been_accepted',
    DAAS_NEARBY_STATUS_TEXT: 'your_order_is_very_closed',
    DAAS_UNASSIGNED_STATUS_TEXT: 'your_order_is_being_prepared',
    DAAS_ASSIGNED_STATUS_TEXT: 'your_order_is_being_prepared',
    DAAS_STARTED_STATUS_TEXT: 'deliveryman_is_navigating_to_restaurant',
    DAAS_ARRIVING_AT_SHOP_STATUS_TEXT: 'deliveryman_is_waiting_to_receive_your_order',
    DAAS_SHIPPING_STATUS_TEXT: 'your_order_is_on_its_way',
    DAAS_SHIPPED_STATUS_TEXT: 'thank_you_for_choosing_us',
    NON_DAAS_THANKYOU_TEXT: 'thank_you_for_choosing_us'
  }
};

function getOrderAcceptedStatusText(order: Order, view: OrderTrackingStatusTextsView): string {
  const texts = orderTrackingStatusTexts[view];

  if (!isOrderDaas(order)) return texts.NON_DAAS_THANKYOU_TEXT;

  const { deliveryStatus, deliveryETA } = order.daasInformation;
  if (isOrderScheduled(order) && deliveryStatus.status === 'UNASSIGNED') return texts.ACCEPTED_STATUS_TEXT;

  const isShipped = deliveryStatus.status === 'SHIPPED';
  if (isShipped) return texts.DAAS_SHIPPED_STATUS_TEXT;

  const currentDate = dayjs();
  const isClose = dayjs(deliveryETA).diff(currentDate, 'minutes') <= 3;
  if (isClose && !isOrderDaasBeforeShipping(order)) return texts.DAAS_NEARBY_STATUS_TEXT;

  switch (deliveryStatus.status) {
    case 'UNASSIGNED':
      return texts.DAAS_UNASSIGNED_STATUS_TEXT;
    case 'ASSIGNED':
      return texts.DAAS_ASSIGNED_STATUS_TEXT;
    case 'STARTED':
      return texts.DAAS_STARTED_STATUS_TEXT;
    case 'ARRIVING_AT_SHOP':
      return texts.DAAS_ARRIVING_AT_SHOP_STATUS_TEXT;
    case 'SHIPPING':
      return texts.DAAS_SHIPPING_STATUS_TEXT;
    default:
      return texts.ACCEPTED_STATUS_TEXT;
  }
}

function getOrderTrackingStatusEstimationText(order: Order): string {
  const isScheduled = isOrderScheduled(order);
  const isTakeAway = order.orderShippingType === 'takeAway';
  if (isTakeAway) return getTakeAwayTrackingStatusEstimationText(order, isScheduled);
  if (!isOrderDaas(order)) return getNonDaasTrackingStatusEstimationText(order, isScheduled);
  return getDaasTrackingStatusEstimationText(order, isScheduled);
}

function getOrderTileStatusEstimationText(order: Order): string {
  const isScheduled = isOrderScheduled(order);
  const isTakeAway = order.orderShippingType === 'takeAway';
  if (isTakeAway) return getTakeAwayTrackingStatusEstimationText(order, isScheduled);
  if (!isOrderDaas(order)) return getNonDaasOrderTileStatusEstimationText(isScheduled);
  return getDaasTrackingStatusEstimationText(order, isScheduled);
}

function getNonDaasOrderTileStatusEstimationText(isScheduled: boolean): string {
  return isScheduled ? 'scheduled_for' : 'in_progress_it_will_be_at_your_door_at_about';
}

function getTakeAwayTrackingStatusEstimationText(order: Order, isScheduled: boolean): string {
  return isOrderCompleted(order)
    ? isNormalOrderDeliveryCompletedToday(order)
      ? 'for_your_order'
      : 'for_your_order_on'
    : isScheduled
      ? 'it_will_be_ready_for_pickup'
      : 'it_will_be_ready_for_pickup_in';
}

function getNonDaasTrackingStatusEstimationText(order: Order, isScheduled: boolean): string {
  if (isOrderCompleted(order))
    return isNormalOrderDeliveryCompletedToday(order) ? 'for_your_order' : 'shipped_at_your_door_at';
  return isScheduled ? 'it_will_be_at_your_door' : 'it_will_be_at_your_door_in';
}

function getDaasTrackingStatusEstimationText(order: Order, isScheduled: boolean): string {
  const status = order?.daasInformation?.deliveryStatus?.status;
  const isShipped = status === 'SHIPPED';
  if (isShipped) return 'shipped_at_your_door_at';
  return isScheduled ? 'it_will_be_at_your_door' : 'order_delivery_in';
}

function getDaasEstimatedArrivalDateString(order: Order): string {
  const fallbackMinutes = isOrderDaasBeforeShipping(order) ? 5 : 1;
  const currentDate = dayjs();
  const etaDate = dayjs(order.daasInformation.deliveryETA);
  const remainingMinutes = etaDate.diff(currentDate, 'minutes');
  return `${remainingMinutes > fallbackMinutes ? remainingMinutes : fallbackMinutes}’`;
}

/* Order Tracking Status Estimation Time */
function getCeiledDeliveryTime(date: dayjs.Dayjs): dayjs.Dayjs {
  const totalMinutes: number = date.minute();
  const units: number = totalMinutes % 10;
  if (units === 0 || units === 5) return date;
  if (units <= 5) return date.add(5 - units, 'minute');
  return date.add(10 - units, 'minute');
}

function getNormalOrderDeliveryEstimationTime(order: Order): dayjs.Dayjs {
  const deliveryEstimationMinutes = order.shopResponse.minutesEstimate;
  const acceptedStatus = getOrderShopStatus(order, 'ACCEPTED');
  if (!acceptedStatus) return;
  const orderPlacementDate: dayjs.Dayjs = dayjs.unix(acceptedStatus.changedAt);
  const orderDeliveryDate: dayjs.Dayjs = orderPlacementDate.add(deliveryEstimationMinutes, 'minutes');
  return getCeiledDeliveryTime(orderDeliveryDate);
}

function isNormalOrderDeliveryCompletedToday(order: Order): boolean {
  const acceptedStatus = getOrderShopStatus(order, 'ACCEPTED');
  if (!acceptedStatus) return false;
  const currentDate = dayjs();
  const shippedDate = dayjs.unix(acceptedStatus.changedAt);
  return currentDate.isSame(shippedDate, 'day');
}

function getNormalOrderDeliveryCompletionTimeText(order: Order): string {
  const acceptedStatus = getOrderShopStatus(order, 'ACCEPTED');
  if (!acceptedStatus) return '';
  return dayjs.unix(acceptedStatus.changedAt).format('DD/MM/YYYY');
}

function getNormalOrderTileStatusEstimationTimeText(order: Order): string {
  if (!order) return;
  const deliveryEstimationTime = getNormalOrderDeliveryEstimationTime(order).format('HH:mm');
  return deliveryEstimationTime;
}

function getNormalOrderDeliveryEstimationTimeText(order: Order, translateFn: GetTextByKeyType): string {
  if (!order.shopResponse.minutesEstimate) return;
  if (isOrderCompleted(order))
    return isNormalOrderDeliveryCompletedToday(order) ? '' : getNormalOrderDeliveryCompletionTimeText(order);
  const deliveryEstimationMinutes = order.shopResponse.minutesEstimate;
  const deliveryEstimationTime = getNormalOrderDeliveryEstimationTime(order).format('HH:mm');
  return translateFn('delivery_estimation_almost_at', {
    _DELIVERY_ESTIMATION_MINUTES: String(deliveryEstimationMinutes),
    _DELIVERY_ESTIMATION_TIME: deliveryEstimationTime
  });
}

function getScheduledOrderDeliveryEstimationTimeText(order: Order, translateFn: GetTextByKeyType): string {
  const currentDate: Date = dayjs().toDate();
  const deliveryStartSlot = dayjs.unix(order.timeSlotStart);
  const deliveryEndSlotText = dayjs.unix(order.timeSlotEnd).format('HH:mm');
  const dateDiff: number = diffDays(deliveryStartSlot.toDate(), currentDate);
  const replacementDictionary: Record<string, string> = {
    _DELIVERY_START_SLOT: deliveryStartSlot.format('HH:mm'),
    _DELIVERY_END_SLOT: deliveryEndSlotText
  };
  if (dateDiff === 0) return translateFn('delivery_today_almost_start_end_slot', replacementDictionary);
  if (dateDiff === 1) return translateFn('delivery_tomorrow_almost_start_end_slot', replacementDictionary);

  return `${dayjs(deliveryStartSlot).format('dddd DD/MM, HH:mm')}-${deliveryEndSlotText}`;
}

function getDAASUnassignedDeliveryEstimationTime(order: Order): string {
  const { deliveryDateFrom, deliveryDateTo } = order.daasInformation;
  if (!deliveryDateFrom || !deliveryDateTo) return;
  const deliveryDateFromText = dayjs(deliveryDateFrom).diff(dayjs(), 'minutes');
  const deliveryDateToText = dayjs(deliveryDateTo).diff(dayjs(), 'minutes');
  const normalizedDateFromText = deliveryDateFromText > 5 ? deliveryDateFromText : 5;
  const normalizedDateToText = deliveryDateToText > 5 ? deliveryDateToText : 5;
  return `${normalizedDateFromText}’ - ${normalizedDateToText}’`;
}

function getDaasShippedOrderTimeOfArrival(order: Order): string {
  const shippedHistoryEntry = getOrderDaasStatus(order, 'SHIPPED');
  if (!shippedHistoryEntry) return;
  const currentDate = dayjs();
  const shippedDate = dayjs.unix(shippedHistoryEntry.changedAt);
  if (currentDate.isAfter(shippedDate)) return dayjs.unix(shippedHistoryEntry.changedAt).format('DD/MM/YY HH:mm');
  return dayjs.unix(shippedHistoryEntry.changedAt).format('HH:mm');
}

function getOrderStatusTimeText(order: Order, translateFn: GetTextByKeyType): string {
  if (isOrderScheduled(order)) return getScheduledOrderDeliveryEstimationTimeText(order, translateFn);

  const daasStatus = order.daasInformation?.deliveryStatus?.status;
  const isTakeaway = order.orderShippingType === 'takeAway';
  if (isTakeaway || !daasStatus) return getNormalOrderDeliveryEstimationTimeText(order, translateFn);

  const daasOrderStatusTimeText = getDaasOrderStatusTimeText(order);
  if (daasOrderStatusTimeText) return daasOrderStatusTimeText;

  return getNormalOrderDeliveryEstimationTimeText(order, translateFn);
}

function getOrderTileStatusTimeText(order: Order, translateFn: GetTextByKeyType): string {
  if (isOrderScheduled(order)) return getScheduledOrderDeliveryEstimationTimeText(order, translateFn);

  const daasStatus = order.daasInformation?.deliveryStatus?.status;
  const isTakeaway = order.orderShippingType === 'takeAway';
  if (isTakeaway || !daasStatus) return getNormalOrderTileStatusEstimationTimeText(order);

  const daasOrderStatusTimeText = getDaasOrderStatusTimeText(order);
  if (daasOrderStatusTimeText) return daasOrderStatusTimeText;

  return getNormalOrderDeliveryEstimationTimeText(order, translateFn);
}

function getDaasOrderStatusTimeText(order: Order): string {
  const daasStatus = order.daasInformation?.deliveryStatus?.status;

  const { deliveryETA, deliveryDateTo, deliveryDateFrom } = order.daasInformation;
  const isDaasShipped = daasStatus === 'SHIPPED';
  if (isDaasShipped) return getDaasShippedOrderTimeOfArrival(order);

  const isDaasUnassigned = daasStatus === 'UNASSIGNED' && deliveryDateFrom && deliveryDateTo;
  if (isDaasUnassigned) return getDAASUnassignedDeliveryEstimationTime(order);

  const isDaasInitialized = daasStatus !== 'UNASSIGNED' && deliveryETA;
  if (isDaasInitialized) return getDaasEstimatedArrivalDateString(order);

  return;
}

function canShowDeliveryMarker(order: Order): boolean {
  if (!isOrderDaas(order)) return false;
  const daasStatusesWithLocationInformation: OrderDaasInfoStatus[] = [
    'STARTED',
    'ARRIVING_AT_SHOP',
    'SHIPPING',
    'SHIPPED'
  ];
  return daasStatusesWithLocationInformation.includes(order.daasInformation.deliveryStatus.status);
}

function canFocusOnUserAndDelivery(order: Order): boolean {
  if (!isOrderDaas(order)) return false;
  const daasStatusesWithLocationInformation: OrderDaasInfoStatus[] = ['SHIPPING', 'SHIPPED'];
  return daasStatusesWithLocationInformation.includes(order.daasInformation.deliveryStatus.status);
}

function shouldShowLiveTrackingMap(order: Order): boolean {
  if (!isOrderDaas(order)) return false;
  if (order.daasInformation.deliveryStatus.status === 'SHIPPED') return false;
  const shopStatus = order.shopResponse.status;
  const trackingShopStatuses = ['ACCEPTED', 'COMPLETED'];
  return trackingShopStatuses.includes(shopStatus) && isNotOrderCompleted(order);
}

function coordinatesToLatLng(coordinates: Coordinates): google.maps.LatLng {
  return new google.maps.LatLng(coordinates.latitude, coordinates.longitude);
}

function getMapZoom(map: GoogleMap): number {
  const initialZoom = map.getZoom();
  return initialZoom - 0.5;
}

function getDaasMapOptions(map: GoogleMap, pinCoordinates: Coordinates[], theme: BoxTheme): google.maps.MapOptions {
  const bounds = new google.maps.LatLngBounds();
  pinCoordinates.map((coordinate) => bounds.extend(coordinatesToLatLng(coordinate)));
  const center = bounds.getCenter();
  map.fitBounds(bounds);
  const styles = getDaasMapStyles(theme);
  return { ...DEFAULT_MAP_OPTIONS, styles, center, zoom: getMapZoom(map) };
}

function getShopMarkerOptions(shopCoordinates: Coordinates): google.maps.MarkerOptions {
  return {
    ...DEFAULT_MARKER_OPTIONS,
    icon: {
      url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(ShopAddressPinSVG),
      scaledSize: new google.maps.Size(46, 54)
    },
    position: coordinatesToLatLng(shopCoordinates),
    zIndex: 2
  };
}

function getDeliveryMarkerOptions(driverPosition: google.maps.LatLng): google.maps.MarkerOptions {
  return {
    ...DEFAULT_MARKER_OPTIONS,
    icon: {
      url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(DeliveryPinSVG),
      scaledSize: new google.maps.Size(46, 54)
    },
    position: driverPosition,
    zIndex: 3
  };
}

function getAddressMarkerOptions(userAddress: Address): google.maps.MarkerOptions {
  const position = coordinatesToLatLng({ latitude: userAddress.latitude, longitude: userAddress.longitude });

  let svg: string;
  const addressType = getAddressType(userAddress.type);
  if (addressType === 'home') {
    svg = HomeAddressPinSVG;
  } else if (addressType === 'work') {
    svg = WorkAddressPinSVG;
  } else {
    svg = GeneralAddressPinSVG;
  }

  return {
    ...DEFAULT_MARKER_OPTIONS,
    icon: {
      url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(svg),
      scaledSize: new google.maps.Size(46, 54)
    },
    zIndex: 1,
    position
  };
}

function orderRequiresPolling(order: Order): boolean {
  if (isOrderRejected(order)) return false;
  if (isOrderScheduled(order)) return true;
  if (isOrderDaas(order)) {
    const isShipped = order.daasInformation?.deliveryStatus?.status === 'SHIPPED';
    return !isShipped;
  } else {
    return isOrderPending(order);
  }
}

function shouldShowDaasTimingsBeforeProgress(order: Order): boolean {
  if (!isOrderDaas(order)) return false;
  if (isOrderScheduled(order)) return false;

  const daasStatus = order.daasInformation.deliveryStatus.status;
  const { deliveryETA, deliveryDateTo, deliveryDateFrom } = order.daasInformation;
  const isDaasUnassigned = daasStatus === 'UNASSIGNED' && deliveryDateFrom && deliveryDateTo;
  if (isDaasUnassigned) return true;
  const isDaasInitialized = daasStatus !== 'UNASSIGNED' && daasStatus !== 'SHIPPED' && deliveryETA;
  if (isDaasInitialized) return true;
}

function generateDaasOrderProgressBarFragments(order: Order): ProgressBarFragment[] {
  if (!isOrderDaas(order)) return [];
  if (isOrderPending(order)) {
    return [
      { shimmerAnimation: true, infiniteSlideAnimation: true, loadedPercentage: 100 },
      { loadedPercentage: 0 },
      { loadedPercentage: 0 },
      { loadedPercentage: 0 }
    ];
  }
  if (isOrderRejected(order)) return [];

  const daasStatus = order.daasInformation.deliveryStatus.status;
  switch (daasStatus) {
    case 'UNASSIGNED':
    case 'ASSIGNED':
    case 'STARTED':
    case 'ARRIVING_AT_SHOP':
      return [
        { loadedPercentage: 100 },
        { shimmerAnimation: true, infiniteSlideAnimation: true, loadedPercentage: 100 },
        { loadedPercentage: 0 },
        { loadedPercentage: 0 }
      ];
    case 'SHIPPING':
      return [
        { loadedPercentage: 100 },
        { loadedPercentage: 100 },
        { shimmerAnimation: true, infiniteSlideAnimation: true, loadedPercentage: 100 },
        { loadedPercentage: 0 }
      ];
    case 'SHIPPED':
      return [
        { loadedPercentage: 100 },
        { loadedPercentage: 100 },
        { loadedPercentage: 100 },
        { shimmerAnimation: false, slideAnimation: true, loadedPercentage: 100 }
      ];
  }
}

function generateOrderProgressBarFragments(order: Order): ProgressBarFragment[] {
  if (isOrderDaas(order)) return generateDaasOrderProgressBarFragments(order);

  if (isOrderPending(order)) {
    return [{ shimmerAnimation: true, infiniteSlideAnimation: true, loadedPercentage: 100 }, { loadedPercentage: 0 }];
  }

  if (isOrderAccepted(order)) {
    const orderDeliveryStatus = getOrderDeliveryStatus(order);
    if (orderDeliveryStatus === 'INPROGRESS') {
      return [{ loadedPercentage: 100 }, { shimmerAnimation: true, slideAnimation: true, loadedPercentage: 100 }];
    }
    if (orderDeliveryStatus === 'COMPLETED') {
      return [{ loadedPercentage: 100 }, { loadedPercentage: 100 }];
    }
  }

  return [];
}

function getCoordinatesFromMarkerOptions(options: google.maps.MarkerOptions): Coordinates {
  if (!options?.position) return;
  return {
    latitude: (options.position as google.maps.LatLng).lat() as number, // eslint-disable-line
    longitude: (options.position as google.maps.LatLng).lng() as number // eslint-disable-line
  };
}

function isMarkerInsideMapBounds(marker: google.maps.MarkerOptions, map: GoogleMap): boolean {
  const markerPosition = marker?.position;
  const mapBounds = map.getBounds();
  if (!markerPosition || !mapBounds) return false;
  return mapBounds.contains(markerPosition);
}
